/**
 * Asset Cache Configuration
 * This file contains configuration utility functions
 */

import type { AssetCacheConfig } from "./types";

// ============================================================================
// CONFIGURATION UTILITY FUNCTIONS
// ============================================================================

/**
 * Merge user configuration with defaults
 * Simple merge of user-provided configuration with default values
 */
export function mergeAssetCacheConfig(
  userConfig: AssetCacheConfig = {}
): Required<AssetCacheConfig> {
  // Validate user configuration first
  validateAssetCacheConfig(userConfig);

  // Import defaults here to avoid circular dependency
  const { getDefaultAssetCacheConfig } = require("./defaults");
  const defaults = getDefaultAssetCacheConfig();

  return {
    ...defaults,
    ...userConfig,
  };
}

/**
 * Validate asset cache configuration
 * Validates user-provided configuration and throws errors for invalid values
 */
export function validateAssetCacheConfig(config: AssetCacheConfig): void {
  // Validate numeric values
  if (config.maxSize !== undefined && config.maxSize <= 0) {
    throw new Error("maxSize must be greater than 0");
  }

  if (config.maxAge !== undefined && config.maxAge <= 0) {
    throw new Error("maxAge must be greater than 0");
  }
}
